import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common'
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

import { getAcronym } from '@teem/helpers/functions';
import { PLAN_TYPES, SUBSCRIPTION_STATUS, USER_TYPE } from '@teem/constants/subscription';
import Swal from 'sweetalert2';
import { messages as i18n } from '@teem/constants/messages';
import { environment } from '@teem/environments/environment';
import { MixpanelService } from '@teem/services/mixpanel.service';
import { STORE_TYPE } from '@teem/app/core/constants/defaults';
// import { FreePlanExpiredModalComponent } from '@teem/layouts/models/free-plan-expired/free-plan-expired-modal.component';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Input() user;
  @Output() viewNotification: EventEmitter<any> = new EventEmitter();
  headerBar: boolean = true;
  freeTrailDays = environment.freeTrailDays;
  freeTrailStartDate = environment.freeTrailStartDate;
  date: Date;
  verifyDate: Date;
  currentRoute: string;
  activeInvoiceRoutes: string[] = ['/invoices', '/payments', '/expenses', '/quotations', '/taxes'];
  activeReportsRoutes: string[] = ['/reports', '/storefront-analytics', '/profit-loss-statement','/monthly-invoice'];
  activeOrderRoutes: string[] = ['/orders', '/store', '/products', '/services', '/branches', '/store?product-listing=true'];

  public notifications: Array<any> = [];
  public unreadNotificationsCount: number = 0;


  @Input('notifications')
  set setNotifications(value: any) {
    this.notifications = value ? value : [];
  }

  @Input('unreadNotificationsCount')
  set notificationsCount(value: number) {
    this.unreadNotificationsCount = value ? value : 0;
  }

  locale: string = 'en';
  userInfo: any;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location,
    private modalService: NgbModal,
    private mixpanelService: MixpanelService,
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.currentRoute = this.router.url;
        // console.log(this.currentRoute);
      }

      if((this.isProPlan() || this.isProfessionalPlan())) {
        this.activeInvoiceRoutes = ['/invoices', '/payments', '/expenses', '/quotations', '/taxes', '/products', '/services'];
        this.activeReportsRoutes = ['/reports', '/storefront-analytics', '/profit-loss-statement','influencer-analytics','/monthly-invoice'];
        this.activeOrderRoutes = ['/orders', '/store', '/store?product-listing=true', '/branches','/products', '/services'];
      }

    });
  }

  ngOnInit(): void {
    this.locale = (window as any).LOCALE;
    this.userInfo  = (window as any).userInfo;
    if (this.isAccessOnlineOrderingPlan()) {
      this.activeOrderRoutes = ['/orders', '/store', '/products', '/services', '/branches', '/store?product-listing=true', '/expenses'];
    }
  }

  isRouteActive(route: string, mainRoute: string): boolean {
    if (mainRoute ==  'invoices') {
      return this.activeInvoiceRoutes.includes(route.split('?')[0]);
    }
    if (mainRoute ==  'reports') {
      return this.activeReportsRoutes.includes(route);
    }
    return this.activeOrderRoutes.includes(route);
  }

  private subscriptionAccess = {
    "basic": ['zatca', 'dashboard', 'branches', 'invoices', 'payments', 'create-invoice', 'expenses', 'quotations', 'proposals', 'clients', 'subscription-plan', 'setting', 'billing', 'users'],
    "pro": ['zatca', 'dashboard', 'branches', 'invoices', 'payments', 'create-invoice', 'expenses', 'quotations', 'proposals', 'clients', 'subscription-plan', 'setting', 'billing', 'taxes', 'services', 'store', 'wallets', 'products', 'orders', 'users'],
    "individual": ['zatca', 'dashboard', 'branches', 'invoices', 'payments', 'create-invoice', 'expenses', 'quotations', 'proposals', 'clients', 'subscription-plan', 'setting', 'billing', 'users'],
    "professional": ['zatca', 'dashboard', 'branches', 'invoices', 'payments', 'create-invoice', 'expenses', 'quotations', 'proposals', 'clients', 'subscription-plan', 'setting', 'billing', 'taxes', 'services', 'store', 'wallets', 'products', 'orders', 'users'],
    "business": ['zatca', 'dashboard', 'branches', 'invoices', 'payments', 'create-invoice', 'expenses', 'quotations', 'proposals', 'clients', 'subscription-plan', 'setting', 'billing', 'taxes', 'services', 'store', 'wallets', 'products', 'orders', 'users', 'reports'],

    "invoice-basic": ['zatca', 'dashboard', 'branches','invoices','payments','create-invoice', 'expenses', 'quotations','clients','subscription-plan','setting','billing', 'services', 'products', 'users'],
    "invoice-pro": ['zatca', 'dashboard', 'branches', 'invoices', 'payments', 'create-invoice', 'expenses', 'quotations', 'proposals', 'clients', 'subscription-plan', 'setting', 'billing', 'services', 'products', 'users'],
    "invoice-enterprise": ['zatca', 'dashboard', 'branches', 'invoices', 'payments', 'create-invoice', 'expenses', 'quotations', 'proposals', 'clients', 'subscription-plan', 'setting', 'billing', 'services', 'products', 'users'],
    "online-store-basic": ['zatca', 'dashboard', 'branches', 'clients', 'subscription-plan', 'setting', 'expenses', 'billing', 'taxes', 'services', 'store', 'wallets', 'products', 'orders', 'users', 'reports'], // 'invoices', 'payments', 'create-invoice', 'expenses', 'proposals',
    "online-store-pro": ['zatca', 'dashboard', 'branches', 'clients', 'subscription-plan', 'setting', 'expenses', 'billing', 'taxes', 'services', 'store', 'wallets', 'products', 'orders', 'users', 'reports'], // 'invoices', 'payments', 'create-invoice', 'expenses', 'proposals',
    "online-store-enterprise": ['zatca', 'dashboard', 'branches', 'clients', 'subscription-plan', 'setting', 'expenses', 'billing', 'taxes', 'services', 'store', 'wallets', 'products', 'orders', 'users', 'reports'], // 'invoices', 'payments', 'create-invoice', 'expenses', 'proposals',
    "online-ordering-basic": ['zatca', 'dashboard', 'branches', 'clients', 'subscription-plan', 'setting', 'expenses', 'billing', 'taxes', 'services', 'store', 'wallets', 'products', 'orders', 'users', 'reports'], // 'invoices', 'payments', 'create-invoice', 'expenses', 'proposals',
    "online-ordering-pro": ['zatca', 'dashboard', 'branches', 'clients', 'subscription-plan', 'setting', 'expenses', 'billing', 'taxes', 'services', 'store', 'wallets', 'products', 'orders', 'users', 'reports'], // 'invoices', 'payments', 'create-invoice', 'expenses', 'proposals',
    "online-ordering-enterprise": ['zatca', 'dashboard', 'branches', 'clients', 'subscription-plan', 'setting', 'expenses', 'billing', 'taxes', 'services', 'store', 'wallets', 'products', 'orders', 'users', 'reports'], // 'invoices', 'payments', 'create-invoice', 'expenses', 'proposals',
    "complete-solution": ['zatca', 'dashboard', 'branches', 'invoices', 'payments', 'create-invoice', 'expenses', 'quotations', 'proposals', 'clients', 'subscription-plan', 'setting', 'billing', 'taxes', 'services', 'store', 'wallets', 'products', 'orders', 'users', 'reports'],
  };

  hasAccessToModule(moduleName: string, userSubscription: string): boolean {
      const allowedModules = this.subscriptionAccess[userSubscription] || [];
      return allowedModules.includes(moduleName);
  }

  isAccessPlan(moduleName: string) {
    const hasAccess = this.hasAccessToModule(moduleName, this.user?.subscription?.subscription_plan);
    return hasAccess;
  }

  isAccessOnlineOrderingPlan() {
    const subscriptionPlan = this.userInfo?.subscription?.subscription_plan; // this.user?.subscription?.subscription_plan;
    if (
      subscriptionPlan == "online-ordering-basic" ||
      subscriptionPlan == "online-ordering-pro" ||
      subscriptionPlan == "online-ordering-enterprise" ||
      subscriptionPlan == "online-store-basic" ||
      subscriptionPlan == "online-store-pro" ||
      subscriptionPlan == "online-store-enterprise"
    ) {
      return true;
    }
    return false;
  }

  get remaningDaysTrialPlan() {
    this.verifyDate = new Date(this.user.verified_at);
    this.date = new Date(this.freeTrailStartDate);
    this.date.setDate(this.date.getDate() + this.freeTrailDays);
    let date1: any = new Date(this.date);
    if (this.verifyDate > new Date(this.freeTrailStartDate)) {
      this.verifyDate.setDate(this.verifyDate.getDate() + this.freeTrailDays);
      date1 = new Date(this.verifyDate);
    }
    let date2: any = new Date();
    let diffDays: any = Math.floor((date1 - date2) / (1000 * 60 * 60 * 24));
    if (diffDays < 0) {
      this.headerBar = false;
    }
    return diffDays;
  }

  get userAcronym() {
    return this.user ? getAcronym(this.user.first_name + ' ' + this.user.last_name) : '';
  }

  isSettlement() {
    if (this.user && this.user.is_myfatoorah_active)
      return true;
    else
      return false;
  }

  isBasicPlan() {
    if (this.user && this.user.subscription && [SUBSCRIPTION_STATUS.active].indexOf(this.user.subscription.subscription_status) != -1)
      return this.user.subscription.subscription_plan == PLAN_TYPES.basic;
    else
      false;
  }

  isBranchStore(){
    if (this.user && this.user?.is_branch && this.user.store_type == STORE_TYPE.PRODUCT && (this.user?.vertical_type == 'food_beverage'))
      return true;
    else
      return false;
  }

  closeHeaderBar() {
    // Mixpanel event sub_upgrade_banner_close_click
    let userProperties = this.mixpanelService.getUserProperties(this.user);
    let trackProperties = this.mixpanelService.getTrackProperties(this.user);
    let combinedProperties = {
      ...userProperties,
      ...trackProperties
    };
    // this.mixpanelService.setUserProperties(userProperties);
    this.mixpanelService.track('sub_upgrade_banner_close_click', combinedProperties);
    if (this.user?.billing_experimente_data?.name) {
      this.mixpanelService.unionUserProperties({ 'experiments': this.user.billing_experimente_data.name })
    }
    this.headerBar = !this.headerBar;
  }

  isProPlan() {
    if (this.user && this.user.subscription && [SUBSCRIPTION_STATUS.active].indexOf(this.user.subscription.subscription_status) != -1)
      return this.user && this.user.subscription && this.user.subscription.subscription_plan == PLAN_TYPES.pro;
    else
      false;
  }

  isIndividualPlan() {
    if (this.user && this.user.subscription && [SUBSCRIPTION_STATUS.active].indexOf(this.user.subscription.subscription_status) != -1)
      return this.user.subscription.subscription_plan == PLAN_TYPES.individual;
    else
      false;
  }

  isProfessionalPlan() {
    if (this.user && this.user.subscription && [SUBSCRIPTION_STATUS.active].indexOf(this.user.subscription.subscription_status) != -1)
      return this.user.subscription.subscription_plan == PLAN_TYPES.professional;
    else
      false;
  }

  isBusinessPlan() {
    if (this.user && this.user.subscription && [SUBSCRIPTION_STATUS.active].indexOf(this.user.subscription.subscription_status) != -1)
      return this.user.subscription.subscription_plan == PLAN_TYPES.business;
    else
      false;
  }

  isUser() {
    if (this.user && this.user?.user_type)
      return (this.user?.user_type == USER_TYPE.user || this.user?.user_type == USER_TYPE.admin || this.user?.user_type == USER_TYPE.super_admin);
    else
      false;
  }

  isAdmin() {
    if (this.user && this.user?.user_type)
      return (this.user?.user_type == USER_TYPE.admin || this.user?.user_type == USER_TYPE.super_admin);
    else
      false;
  }

  isSuperAdmin() {
    if (this.user && this.user?.user_type)
      return this.user?.user_type == USER_TYPE.super_admin;
    else
      false;
  }

  get pendingInvoiceCount() {
    if (this.user && this.user.permissions && this.user.permissions.pending_invoices)
      return this.user.permissions.pending_invoices;

    return 0;
  }

  get allowCreateInvoice() {
    if (this.user && this.user.permissions && this.user.permissions.create_invoice)
      return this.user.permissions.create_invoice;

    return false;
  }

  get pendingPaymentCount() {
    return this.user?.pending_invoices;
  }

  get planName() {
    // return 'basic';
    if (this.user?.subscription?.original_subscription_plan == 'free') {
      return 'free';
    }
    return this.user && this.user.subscription ? this.user.subscription.subscription_plan : '';
  }

  get originalPlanName() {
    return this.user && this.user.subscription ? this.user.subscription.original_subscription_plan : 'free';
  }

  navigateToPlans() {
    // Mixpanel event sub_upgrade_banner_click
    let userProperties = this.mixpanelService.getUserProperties(this.user);
    let trackProperties = this.mixpanelService.getTrackProperties(this.user);
    let combinedProperties = {
      ...userProperties,
      ...trackProperties
    };
    // this.mixpanelService.setUserProperties(userProperties);
    this.mixpanelService.track('sub_upgrade_banner_click', combinedProperties);
    if (this.user?.billing_experimente_data?.name) {
      this.mixpanelService.unionUserProperties({ 'experiments': this.user.billing_experimente_data.name })
    }
    if (this.user?.billing_experimente_data?.is_experiment == 1) {
      this.router.navigate(['/billing']);
    } else {

      this.router.navigate(['/setting'], { queryParams: { 'tab': 'plans' } });
    }
  }

  navigateToBilling() {
    // Mixpanel event sub_page_click
    let userProperties = this.mixpanelService.getUserProperties(this.user);
    let trackProperties = this.mixpanelService.getTrackProperties(this.user);

          let combinedProperties = {
            ...userProperties,
            ...trackProperties
          };
    this.mixpanelService.setUserProperties(userProperties);
    this.mixpanelService.track('sub_page_click', combinedProperties);
    if (this.user?.billing_experimente_data?.name) {
      this.mixpanelService.unionUserProperties({ 'experiments': this.user.billing_experimente_data.name })
    }
    this.router.navigate(['/billing']);

  }

  // isEmpty(obj: any): boolean {
  // 	return obj == null || Object.keys(obj).length === 0;
  // }
  upgradeToCreateInvoice() {
    Swal.fire(i18n.invoice.upgrade_account_to_create_more_invoice, "", 'warning');
    return;
  }

  navigateToInvoices() {
    if (this.router.url == '/invoices') {
      window.location.reload();
    } else {
      this.router.navigateByUrl('/invoices');
    }

  }
}
